<template>
  <!-- v-if: mount a fresh v-dialog per confirm. A single long-lived instance toggled
       repeatedly can end up with its overlay shown but the dialog never activated. -->
  <app-custom-dialog
    v-if="open"
    :key="openCount"
    :value="true"
    :title="dialog.title"
    :is_translate="false"
    :width="dialog.width"
    :cancel-text="dialog.cancelText"
    :submit-text="dialog.confirmText"
    :submit-color="dialog.confirmColor"
    :show-cancel="dialog.showCancel"
    :cancel-text-translate="false"
    :submit-text-translate="false"
    :close-btn="false"
    @input="handleInput"
    @cancel="handleInput(false)"
    @submit="confirm"
  >
    <div slot="activator" class="confirm-dialog-message">
      {{ dialog.text }}
    </div>
  </app-custom-dialog>
</template>

<script>
import { confirmDialogBus } from "@/utils/confirmDialog";

const defaultDialog = () => ({
  title: "",
  text: "",
  cancelText: "",
  confirmText: "",
  confirmColor: "primary",
  showCancel: true,
  width: "420px",
});

export default {
  name: "ConfirmDialog",
  data() {
    return {
      open: false,
      openCount: 0,
      dialog: defaultDialog(),
      resolver: null,
    };
  },
  created() {
    confirmDialogBus.$on("open", this.openDialog);
  },
  beforeDestroy() {
    confirmDialogBus.$off("open", this.openDialog);
    this.resolve(false);
  },
  methods: {
    openDialog({ dialog, resolve }) {
      this.resolve(false);
      this.dialog = { ...defaultDialog(), ...dialog };
      this.resolver = resolve;
      this.openCount += 1;
      this.open = true;
    },
    handleInput(value) {
      this.open = value;
      if (!value) {
        this.resolve(false);
      }
    },
    confirm() {
      this.resolve(true);
    },
    resolve(isConfirmed) {
      const resolver = this.resolver;
      this.resolver = null;
      this.open = false;
      if (resolver) {
        resolver({ isConfirmed });
      }
    },
  },
};
</script>

<style scoped>
.confirm-dialog-message {
  white-space: pre-line;
}
</style>
